import { Network } from "@capacitor/network";
import i18n from "../../i18n/i18next";
import { defaultAddSnack } from "../../state/overlayState/overlayContext";
import { useConnectivityStore } from "./connectivity.store";

Network.addListener("networkStatusChange", (status) => {
  console.log("Network status changed", status);
  // `applyNetworkStatus` folds the previous-value read and both writes into one
  // transition and reports which transition happened, so the snack fires exactly
  // when the old `!isConnectivityAvailable.value` / `isConnectivityAvailable.value`
  // guards fired.
  const transition = useConnectivityStore.getState().applyNetworkStatus(status.connected);

  if (transition === "online") defaultAddSnack(i18n.t("snack.online"), "success", false);
  if (transition === "offline") defaultAddSnack(i18n.t("snack.offline"), "error", false);
});
